import { useUserLobbyRecommendationQuery } from '~/client/features/RecommendedGames/RecommendedGamesCarousel/graphql/UserLobbyRecommendationQuery.generated';
import useAgentData from '~/client/hooks/useAgentData';
import useLanguage from '~/client/hooks/useLanguage';
import useCurrentUser from '~/client/hooks/user/useCurrentUser';
import useSite from '~/client/hooks/useSite';
import type { currencyConversion } from '~/schema/public';

const useRecommendedGamesList = (skip?: boolean) => {
  const { site } = useSite();
  const { isMobile } = useAgentData();
  const { code: language } = useLanguage();
  const { walletCurrency } = useCurrentUser();
  const currency = walletCurrency as currencyConversion;

  const { data, loading } = useUserLobbyRecommendationQuery({
    skip,
    variables: { site, first: 30, language, currency, isMobile },
  });

  const games = data?.casino?.hub88UserLobbyRecommendation?.edges;
  return { loading, games };
};

export default useRecommendedGamesList;
